import { supabase } from "@/utils/supabase";
import { ManufacturerMapper } from "@/adapters/Manufacturer.mapper";
import { getRootStore } from "@/stores/RootStore";
export class ManufacturerService {
    async getManufacturersWithParams(params) {
        try {
            let query = supabase()
                .from("Manufacturers")
                .select("*", { count: "exact" })
                .eq("isDeleted", false);
            // Фильтры
            if (params.filters) {
                const search = params.filters.search?.trim();
                if (search) {
                    const ors = [
                        `name.ilike.*${search}*`,
                        `contactPerson.ilike.*${search}*`,
                        `contactEmail.ilike.*${search}*`,
                        `contactPhone.ilike.*${search}*`,
                        `website.ilike.*${search}*`,
                        `address.ilike.*${search}*`,
                        `notes.ilike.*${search}*`,
                    ];
                    query = query.or(ors.join(","));
                }
            }
            // Сортировка
            if (params.sorters && Object.keys(params.sorters).length > 0) {
                Object.entries(params.sorters).forEach(([field, order]) => {
                    if (order === "ascend")
                        query = query.order(field, { ascending: true });
                    else if (order === "descend")
                        query = query.order(field, { ascending: false });
                });
            }
            else {
                query = query.order("name", { ascending: true });
            }
            // Пагинация
            const from = (params.page - 1) * params.pageSize;
            query = query.range(from, from + params.pageSize - 1);
            const { data, error, count } = await query;
            if (error)
                throw error;
            return {
                data: data.map(ManufacturerMapper.toDomain),
                total: count || 0,
                page: params.page,
                pageSize: params.pageSize,
            };
        }
        catch (error) {
            console.error("Error in getManufacturersWithParams:", error);
            throw error;
        }
    }
    async getManufacturersByIds(ids) {
        const { data, error } = await supabase()
            .from("Manufacturers")
            .select("*")
            .in("id", ids)
            .eq("isDeleted", false);
        if (error) {
            throw error;
        }
        return data.map(ManufacturerMapper.toDomain);
    }
    async createManufacturer(manufacturerData) {
        try {
            const currentUserId = getRootStore().authStore.user?.id;
            const manufacturerDto = ManufacturerMapper.toCreateDto({
                ...manufacturerData,
                idCreatedBy: currentUserId,
            });
            const { data, error } = await supabase()
                .from("Manufacturers")
                .insert([manufacturerDto])
                .select()
                .single();
            if (error)
                throw error;
            return ManufacturerMapper.toDomain(data);
        }
        catch (error) {
            console.error("Error creating manufacturer:", error);
            throw error;
        }
    }
    async updateManufacturer(id, manufacturerData) {
        try {
            const currentUserId = getRootStore().authStore.user?.id;
            const manufacturerDto = ManufacturerMapper.toCreateDto({
                ...manufacturerData,
                idUpdatedBy: currentUserId,
            });
            const { data, error } = await supabase()
                .from("Manufacturers")
                .update(manufacturerDto)
                .eq("id", id)
                .select()
                .single();
            if (error)
                throw error;
            return ManufacturerMapper.toDomain(data);
        }
        catch (error) {
            console.error("Error updating manufacturer:", error);
            throw error;
        }
    }
    async deleteManufacturer(id) {
        try {
            const currentUserId = getRootStore().authStore.user?.id;
            const { error } = await supabase()
                .from("Manufacturers")
                .update({
                isDeleted: true,
                idUpdatedBy: currentUserId,
            })
                .eq("id", id);
            if (error)
                throw error;
        }
        catch (error) {
            console.error("Error deleting manufacturer:", error);
            throw error;
        }
    }
}
// Экспортируем singleton
export const manufacturerService = new ManufacturerService();
